import { SingleFileViewerUploadEmptyStateStyled } from './styles/SingleFileViewerUploadEmptyStateStyled'
import { UploadComponents as UploadComponents } from '../../../Upload'
import { EmptyState } from '@ui/blocks/EmptyState'
import { useUploadContext } from '@ui/blocks/Upload/UploadContext'

export const SingleFileViewerUploadEmptyState = () => {
  const { commonProps } = useUploadContext()

  const { strings } = commonProps

  return (
    <SingleFileViewerUploadEmptyStateStyled>
      <EmptyState
        content={strings.uploadEmptyStateText}
        context='activity'
        button={<UploadComponents.UploadButton commonProps={commonProps} />}
      />
    </SingleFileViewerUploadEmptyStateStyled>
  )
}
